export let OrderKeys = {
  accelerationStatus: 'accelerationStatus',
  accelerationUpdatedAt: 'accelerationUpdatedAt',
  actualRunTime: 'actualRunTime',
  adminCount: 'adminCount',
  alphabeticalAscending: 'AZ',
  alphabeticalDescending: 'ZA',
  askDataMode: 'askDataMode',
  authoringEnabled: 'authoringEnabled',
  availability: 'availability',
  averageQueueTime: 'averageQueueTime',
  averageRunTime: 'averageRunTime',
  childProjectCount: 'childProjectCount',
  completedAt: 'completedAt',
  connectedApplicationClientId: 'id',
  connectedApplicationDomains: 'domainSafelist',
  connectedApplicationScope: 'projectId',
  connectedApplicationStatus: 'enabled',
  connectedViewName: 'connectedViewName',
  connectedWorkbooksCount: 'connectedWorkbooksCount',
  connectionTypeDisplayName: 'connectionTypeDisplayName',
  connectionTypeDisplayNameCrass: 'connectionType',
  containerName: 'containerName',
  contentTypeOrder: 'contentTypeOrder',
  createdAt: 'createdAt',
  createdTime: 'createdTime',
  creatorName: 'creatorName',
  currentLoggedInUserCount: 'currentLoggedInUserCount',
  currentQueueTime: 'currentQueueTime',
  currentRunTime: 'currentRunTime',
  dataRefreshedTimestamp: 'dataRefreshedTimestamp',
  databasesCount: 'databaseCount',
  datasourceCount: 'datasourceCount',
  dataType: 'dataType',
  dateAdded: 'dateAdded',
  definition: 'definition', // definition of a remote refresh schedule, for Data Sync
  displayName: 'displayName',
  domainName: 'domainName',
  downstreamDataSourceCount: 'downstreamDataSourceCount',
  downstreamWorkbookCount: 'downstreamWorkbookCount',
  estimatedDiskUsageKb: 'estimatedDiskUsageKb',
  extractEncryptionMode: 'extractEncryptionMode',
  extractsConcurrencyLimit: 'extractsConcurrencyLimit',
  failureType: 'failureType',
  favoritesTotal: 'favoritesTotal',
  flowFileType: 'flowFileType',
  flowName: 'flowName',
  flowOutputStepName: 'flowOutputStepName',
  flowOutputSteps: 'flowOutputSteps',
  flowScheduleType: 'flowScheduleType',
  flowsConcurrencyLimit: 'flowsConcurrencyLimit',
  flowParameters: 'flowParameters',
  grantLicenseMode: 'grantLicenseMode',
  groupCount: 'groupCount',
  guestAccessEnabled: 'guestAccessEnabled',
  hasAlert: 'hasAlert',
  hasDataPolicy: 'hasDataPolicy',
  hasExtracts: 'hasExtracts',
  hitsLastOneMonthTotal: 'hitsLastOneMonthTotal',
  hitsLastThreeMonthsTotal: 'hitsLastThreeMonthsTotal',
  hitsLastTwelveMonthsTotal: 'hitsLastTwelveMonthsTotal',
  hitsLastTwoWeeksTotal: 'hitsLastTwoWeeksTotal',
  hitsTotal: 'hitsTotal',
  index: 'index',
  isCertified: 'isCertified',
  isDefault: 'isDefault',
  itemCount: 'itemCount',
  jobId: 'jobId',
  jobRequestedTime: 'jobRequestedTime',
  lastAccessedAt: 'lastAccessedAt', // used for GetDetailedRecents queries
  lastChecked: 'lastChecked',
  lastMonthJobAvgTimeInSec: 'lastMonthJobAvgTimeInSec',
  lastMonthJobCount: 'lastMonthJobCount',
  lastMonthViewCount: 'lastMonthViewCount',
  avgLoadTimeWithMaterialization: 'avgLoadTimeWithMaterialization',
  avgLoadTimeWithoutMaterialization: 'avgLoadTimeWithoutMaterialization',
  lastRefreshedAt: 'lastRefreshedAt',
  lastRunAt: 'lastRunAt',
  lastSentAt: 'lastSentAt',
  lastSignIn: 'lastSignIn',
  licenseLevel: 'subscriptionLicensingRole',
  linkedTask: 'linkedTask',
  locationName: 'locationName',
  maxSiteRole: 'maxSiteRole',
  metricsEnabled: 'metricsEnabled',
  metricUpdated: 'metricUpdated',
  metricValue: 'metricValue',
  minimumSiteRole: 'minimumSiteRole',
  modifiedBy: 'modifiedBy',
  name: 'name',
  notificationIntervalInMinutes: 'notificationIntervalInMinutes',
  numericAscending: 'least',
  numericDescending: 'most',
  numSheets: 'numSheets',
  ownerName: 'ownerName',
  parallel: 'parallel',
  parentName: 'parentName',
  permissionedItemCount: 'permissionedItemCount',
  position: 'position', // used for favorites and collections
  priority: 'priority',
  projectName: 'projectName',
  publishedDataSourceName: 'publishedDataSourceName',
  refreshType: 'refreshType', // full or incremental remote refresh, for Data Sync
  relevance: 'relevancy',
  rowsProduced: 'rowsProduced',
  runNextAt: 'runNextAt',
  runtimeLimit: 'runtimeLimit',
  scheduledAction: 'scheduledAction',
  scheduleName: 'scheduleName',
  scheduleType: 'scheduleType',
  sharedAt: 'sharedAt',
  sharedBy: 'sharedBy',
  sharedCustomizedView: 'sharedCustomizedView',
  sharedWith: 'sharedWith',
  sheetImageEnabled: 'sheetImageEnabled',
  siteAdminsCanAddUsers: 'siteAdminsCanAddUsers',
  siteCount: 'siteCount',
  siteId: 'siteId',
  siteName: 'siteName',
  siteRole: 'siteRole',
  size: 'size',
  startedAt: 'startedAt',
  status: 'status',
  storageQuotaBytes: 'storageQuotaBytes',
  storageQuotaPercentUsed: 'storageQuotaPercentUsed',
  storageUsedBytes: 'storageUsedBytes',
  subject: 'subject',
  subscriptionsConcurrencyLimit: 'subscriptionsConcurrencyLimit',
  subscriptionsTotal: 'subscriptionsTotal',
  tableColumns: 'columns',
  tablesCount: 'tableCount',
  tableDatabase: 'database',
  targetName: 'targetName',
  targetType: 'targetType',
  taskCount: 'taskCount',
  taskType: 'taskType',
  timeAscending: 'oldest',
  timeDescending: 'newest',
  title: 'title',
  type: 'type',
  typeForCrass: 'typeForCrass',
  updatedAt: 'updatedAt',
  updatedTime: 'updatedTime',
  urlName: 'urlName',
  userCount: 'userCount',
  userDisplayName: 'userName', // "displayName" property for the user associated with an item
  username: 'username', // "username" property of a user
  userQuota: 'userQuota',
  versionNumber: 'versionNumber',
  viewCount: 'viewCount',
  viewName: 'viewName',
  visibility: 'visibility',
  workbookCount: 'workbookCount',
  workbookName: 'workbookName',
};
